export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "l'Arabe",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "l'Allemand",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "le Grec",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "l'Anglais",
    locale_en_gb_label_secondary: "",
    locale_en_us_label_primary: "l'Anglais",
    locale_en_us_label_secondary: "Américain",
    locale_es_es_label_primary: "l'Espagnol",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "l'Espagnol",
    locale_es_la_label_secondary: "Amérique latine",
    locale_fa_ir_label_primary: "le Farsi",
    locale_fa_ir_label_secondary: "",
    locale_fr_fr_label_primary: "le Français",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "l'Irlandais",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "l'Hébreu",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "l'Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "l'Italien",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "le Japonais",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "le Coréen",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "le Néerlandais",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "le Polonais",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "le Portugais",
    locale_pt_br_label_secondary: "",
    locale_ru_ru_label_primary: "le Russe",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "le Suédois",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "le Filipino",
    locale_tl_ph_label_secondary: "",
    locale_tr_tr_label_primary: "le Turc",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "le Vietnamien",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "le Chinois",
    locale_zn_cn_label_secondary: "",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Magazine",
    nav_primary_catalog_label: "Langues Et Tarification",
    nav_primary_catalog_select_language_label: "Sélectionnez une langue:",
    nav_primary_contact_label: "Contact",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Avoir des questions? Appelez nous:",
    nav_primary_phone_number: "1 (800) ROSETTA",
    nav_primary_sign_in_label: "SE CONNECTER",
    nav_primary_support_label: "Assistance",
    nav_primary_switch_language: "Español",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "Pour Les Éducateurs",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Pour Les Entreprises",
    nav_primary_vertical_for_young_learners_label: "",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Accueil",
    nav_secondary_enterprise_label: "Entreprise",
    nav_secondary_enterprise_resources_label: "Ressources",
    nav_secondary_enterprise_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Accueil",
    nav_secondary_education_primary_label: "Éducation",
    nav_secondary_education_primary_resources_label: "Ressources",
    nav_secondary_education_primary_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "Accueil",
    nav_secondary_education_secondary_label: "Éducation Supérieur",
    nav_secondary_education_secondary_resources_label: "Ressources",
    nav_secondary_education_secondary_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Reconnu depuis 25+ ans par les plus grandes organisations,",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "Que disent les gens à notre propos.",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;<em>L'étalon d’or</em> de l'apprentissage interactif des langues.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;J'adore le logiciel de Rosetta Stone et je pense que <em>tl’approche de l'apprentissage linguistique fonctionne.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;Grâce à l’excellente interface utilisateur, des instructions claires, la grande variété de jeux et défis,<em>Rosetta Stone est très attrayant.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "Keep Exploring",
    related_resources_button_label: "Read more",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "Quel type d'apprenant êtes-vous?",
    verticals_education_primary: "Éducation",
    verticals_education_secondary: "Éducation Supérieur",
    verticals_enterprise: "Entreprise",
    verticals_publicsector: "",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_email_sub_label: "",
    footer_cta_form_comments: "",
    footer_cta_form_country: "",
    footer_cta_form_email: "Email",
    footer_cta_form_firstname: "Prénom",
    footer_cta_form_lastname: "Nom",
    footer_cta_form_organization: "Nom de l'Organisation",
    footer_cta_form_organizationsize: "Taille de l'Organisation",
    footer_cta_form_organizationsize_100: "100 ou Moins",
    footer_cta_form_organizationsize_500: "101 - 500",
    footer_cta_form_organizationsize_1000: "501 - 1,000",
    footer_cta_form_organizationsize_5000: "1,001 - 5,000",
    footer_cta_form_organizationsize_10000: "5,001 - 10,000",
    footer_cta_form_organizationsize_25000: "10,001 - 25,000",
    footer_cta_form_organizationsize_50000: "25,001 - 50,000",
    footer_cta_form_organizationsize_more: "50,001 - Plus",
    footer_cta_form_phone: "Numéro de Téléphone (Facultatif)",
    footer_cta_form_pricing_thanks: "Merci de votre intérêt! Quelqu'un vous suivra sous peu.",
    footer_cta_form_role: "Rôle (ou titre)",
    footer_cta_form_role_boardmember: "Membre d'Équipage",
    footer_cta_form_role_curriculumdirector: "Directeur du curriculum / coordinateur de l'instruction",
    footer_cta_form_role_director: "Réalisateur",
    footer_cta_form_role_executive: "Direction Générale / Executive",
    footer_cta_form_role_individualcontributor: "Contributeur Individuel",
    footer_cta_form_role_manager: "Directeur",
    footer_cta_form_role_principal: "Directeur d'École",
    footer_cta_form_role_superintendent: "Surintendant / Administrateur de district",
    footer_cta_form_role_teacher: "Professeur",
    footer_cta_form_role_techcoordinator: "Coordinateur Technologique",
    footer_cta_form_role_vicepresident: "Vice-Président",
    footer_cta_form_submit: "CONSULTATION GRATUITE",
    footer_cta_how_hear_blog: "Blog",
    footer_cta_how_hear_email: "Email",
    footer_cta_how_hear_event: "Event",
    footer_cta_how_hear_online: "En ligne",
    footer_cta_how_hear_other: "Autre",
    footer_cta_how_hear_referral: "Référence",
    footer_cta_how_hear_search: "Moteur de recherche",
    footer_cta_how_hear_social: "Médias sociaux",
    footer_cta_how_hear_title: "Comment avez-vous entendu parler de nous? (Optionnel)",
    footer_cta_how_hear_webinar: "Séminaire en ligne",
    footer_cta_opt_in_learn_more_button_text: "ici",
    footer_cta_opt_in_learn_more_link_text_1: "ici.",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl:
        "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
    footer_cta_opt_in_learn_more_text_1:
        "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: ".",
    footer_cta_opt_in_text_after_button: "pour plus d'informations.",
    footer_cta_opt_in_text_before_button:
        "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
    footer_cta_pricing_button: "DEMANDE DE TARIFS",
    footer_cta_pricing_label: "Vous cherchez une liste de pas?",
    footer_cta_pricing_subtitle: "S'il vous plaît compléter et nous vous contacterons immédiatement.",
    footer_cta_pricing_title: "Obtenez les informations sur nos tarifs.",

    // Menu
    footer_menu_about_about_us_label: "Rosetta Stone",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Carrières",
    footer_menu_about_contact_label: "Contactez-nous",
    footer_menu_about_label: "À PROPOS",
    footer_menu_about_press_label: "Presse",
    footer_menu_products_demo_label: "Essayez gratuitement",
    footer_menu_products_education_primary_label: "Pour Les Éducateurs",
    footer_menu_products_education_secondary_label: "Pour les Éducateurs Supérieurs",
    footer_menu_products_enterprise_label: "Pour Les Entreprises",
    footer_menu_products_label: "PAR OÙ COMMENCER",
    footer_menu_products_mobile_label: "Applications Mobiles",
    footer_menu_products_reviews_label: "Avis Clients",
    footer_menu_support_faqs_label: "FAQ",
    footer_menu_support_label: "Assistance",
    footer_menu_support_support_site_label: "ASSISTANCE",
    footer_menu_support_system_requirements_label: "Configurations Requises",

    // Meta
    footer_meta_agreements_label: "Mentions Légales",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Paramètres des cookies",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: "Rosetta Stone Ltd. Tous droits réservés",
    footer_meta_privacy_policy_label: "Politique de confidentialité",
    footer_meta_terms_conditions_label: "Modalités et Conditions",

    // Region
    footer_region_label: "Changer de région",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Connecte-toi avec nous",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
